import {
  ListReasonsCommandInput,
  ListReasonsCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { reasonKeys } from 'src/data/api/helios-service-ts/reason/queries/keys';
import { reasonService } from 'src/data/api/helios-service-ts/reason/service';

/**
 * React Query hook for listing reasons from the Helios service.
 *
 * Automatically handles caching, refetching, and error states.
 * The query is enabled by default (no divisionName guard).
 */
export const useListReasonsQuery = (
  input: ListReasonsCommandInput,
  options?: Omit<
    UseQueryOptions<ListReasonsCommandOutput, Error, ListReasonsCommandOutput, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    ...options,
    queryKey: reasonKeys.list(input),
    queryFn: () => reasonService.list(input),
    enabled: options?.enabled !== false,
  });
};
